/* NAELIS — interazioni delle sezioni naelis-*. Vanilla JS, nessuna dipendenza. */
(function () {
  'use strict';
  if (window.__naelisJS) return; window.__naelisJS = true;

  function eur(cents) {
    try { return new Intl.NumberFormat('it-IT', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format((cents || 0) / 100); }
    catch (e) { return '€' + ((cents || 0) / 100).toFixed(2).replace('.', ','); }
  }
  function readJSON(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function once(el, key) { if (!el || el.getAttribute('data-nx-' + key)) return false; el.setAttribute('data-nx-' + key, '1'); return true; }
  function starsHTML(v) {
    var out = '';
    for (var i = 0; i < 5; i++) { var f = Math.max(0, Math.min(1, v - i)) * 100; out += '<i>★<b style="width:' + f + '%">★</b></i>'; }
    return out;
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function zoomer(scope) {
    var dlg = scope.querySelector('[data-zoom-dialog]'); if (!dlg) return function () {};
    var img = dlg.querySelector('[data-zoom-img]');
    dlg.querySelector('[data-zoom-close]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    return function (src, alt) { if (!dlg.showModal) return; img.src = src; img.alt = alt || ''; dlg.showModal(); };
  }

  /* ---------- Reveal on scroll ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  function reveal(scope) {
    scope.querySelectorAll('.nx-reveal:not(.is-in)').forEach(function (el) { if (io) io.observe(el); else el.classList.add('is-in'); });
  }

  /* ---------- I 48 colori: dati condivisi (snippet naelis-tones) ---------- */
  var TONES = null;
  function tones() {
    if (TONES && TONES.tones.length) return TONES;
    var d = readJSON(document.getElementById('naelis-tones')) || { cats: [], tones: [] };
    d.byKey = {}; d.byN = {};
    d.tones.forEach(function (t) { t.label = t.n + ' · ' + t.name; d.byN[t.n] = t; d.byKey[t.name.toLowerCase()] = t; d.byKey[t.label.toLowerCase()] = t; });
    TONES = d; return d;
  }
  /* valore salvato nell'ordine ("043 · Borgogna" o, per i vecchi ordini, "Borgogna") → tonalità */
  function toneOf(v) {
    var d = tones(), s = String(v || '').trim().toLowerCase();
    return d.byKey[s] || d.byKey[s.replace(/^\d+\s*[·.\-]?\s*/, '')] || null;
  }
  function sw(t, cls) { return '<span class="nx-sw' + (cls ? ' ' + cls : '') + '" style="--c:' + esc(t && t.hex ? t.hex : '#efe3e2') + '" aria-hidden="true"></span>'; }
  /* ---------- Penne per colore (backend): un prodotto per fascia, una variante per colore ---------- */
  var PENS = null;
  function pens() {
    if (PENS) return PENS;
    var d = readJSON(document.getElementById('naelis-pens')) || { tiers: {} };
    d.tiers = d.tiers || {}; d.byV = {};
    Object.keys(d.tiers).forEach(function (k) { var t = d.tiers[k]; t.key = k; Object.keys(t.v || {}).forEach(function (n) { d.byV[t.v[n]] = { tier: k, n: n }; }); });
    PENS = d; return d;
  }
  function newSid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
  /* righe carrello di un set: una per colore, quantità = quante volte è ripetuto; null se manca qualcosa */
  function penItems(tierKey, ns, sid) {
    var t = pens().tiers[tierKey]; if (!t || !t.ok || ns.length !== t.size) return null;
    var c = {}, order = [];
    for (var i = 0; i < ns.length; i++) { var n = ns[i]; if (!t.v[n]) return null; if (!c[n]) { c[n] = 0; order.push(n); } c[n]++; }
    return order.map(function (n) { return { id: t.v[n], quantity: c[n], properties: { _set: sid } }; });
  }

  /* "Scegli per me": un mix vario e portabile, poi una tonalità per famiglia a giro */
  var MIX = ['002', '043', '005', '044', '003', '024', '033', '015', '020', '014', '010', '037'];
  function suggest(have, need, avoid) {
    var d = tones(), out = have.slice(), skip = (avoid || []).concat(have), pool = MIX.filter(function (n) { return d.byN[n]; });
    var byCat = d.cats.map(function (c) { return d.tones.filter(function (t) { return t.cat === c.name; }).map(function (t) { return t.n; }); });
    for (var r = 0; r < 12; r++) byCat.forEach(function (l) { if (l[r]) pool.push(l[r]); });
    for (var i = 0; i < pool.length && out.length < need; i++) if (out.indexOf(pool[i]) < 0 && skip.indexOf(pool[i]) < 0) out.push(pool[i]);
    while (out.length < need && d.tones.length) out.push(d.tones[out.length % d.tones.length].n);
    return out;
  }

  /* ---------- Pannello di scelta dei colori (pagina prodotto e carrello) ---------- */
  var SH = null;
  function sheet() {
    if (SH) return SH;
    var d = tones(), el = document.createElement('dialog');
    el.className = 'nx nx-sheet'; el.setAttribute('aria-labelledby', 'nx-sheet-title');
    el.innerHTML = '<div class="nx-sheet__panel">' +
      '<header class="nx-sheet__head"><div><span class="nx-eyebrow">' + d.tones.length + ' colores · también repetidos</span><h2 id="nx-sheet-title" data-sheet-title></h2><p class="nx-sheet__note" data-sheet-note hidden></p></div>' +
      '<button type="button" class="nx-sheet__x" data-sheet-x aria-label="Cerrar">×</button></header>' +
      '<div class="nx-sheet__picked" data-sheet-picked aria-live="polite"></div>' +
      '<p class="nx-sheet__msg" data-sheet-msg role="status" aria-live="polite"></p>' +
      '<nav class="nx-sheet__cats" aria-label="Familias de colores">' + d.cats.map(function (c, i) { return '<button type="button" data-sheet-cat="' + i + '"' + (i ? '' : ' class="is-on"') + '>' + esc(c.name) + '</button>'; }).join('') + '</nav>' +
      '<div class="nx-sheet__body" data-sheet-body>' + d.cats.map(function (c, i) {
        return '<section class="nx-sheet__fam" data-sheet-fam="' + i + '"><h3>' + esc(c.name) + (c.sub ? ' <small>' + esc(c.sub) + '</small>' : '') + '</h3><div class="nx-sheet__grid">' +
          d.tones.filter(function (t) { return t.cat === c.name; }).map(function (t) {
            return '<button type="button" class="nx-pick" data-pick="' + esc(t.n) + '" aria-label="' + esc(t.name + ', número ' + t.n) + '">' + sw(t, 'nx-sw--nail') + '<b>' + esc(t.name) + '</b><small>' + esc(t.n) + '</small><i class="nx-pick__n" hidden></i></button>';
          }).join('') + '</div></section>';
      }).join('') + '<p class="nx-sheet__disc">Colores orientativos: el resultado puede variar según la pantalla, la luz y el número de capas.</p></div>' +
      '<footer class="nx-sheet__foot"><button type="button" class="nx-sheet__auto" data-sheet-auto><svg viewBox="0 0 40 40" width="12" height="12" aria-hidden="true"><path d="M20 0c1.2 10.6 4.6 15 20 20-15.4 5-18.8 9.4-20 20-1.2-10.6-4.6-15-20-20 15.4-5 18.8-9.4 20-20z" fill="currentColor"/></svg> Elige por mí</button>' +
      '<button type="button" class="nx-btn" data-sheet-ok></button></footer></div>';
    document.body.appendChild(el);
    var q = function (s) { return el.querySelector(s); }, body = q('[data-sheet-body]'), st = { need: 1, picked: [], o: {} }, msgT = null;
    function msg(t) { var m = q('[data-sheet-msg]'); m.textContent = t || ''; clearTimeout(msgT); if (t) msgT = setTimeout(function () { m.textContent = ''; }, 3200); }
    function render() {
      var left = st.need - st.picked.length, counts = {};
      st.picked.forEach(function (n) { counts[n] = (counts[n] || 0) + 1; });
      q('[data-sheet-title]').textContent = st.o.title || (st.need === 1 ? 'Elige tu color' : 'Elige tus ' + st.need + ' colores');
      var html = '';
      for (var i = 0; i < st.need; i++) {
        var t = d.byN[st.picked[i]];
        html += t ? '<button type="button" class="nx-sheet__slot is-on" data-sheet-rm="' + i + '" aria-label="Quitar ' + esc(t.name) + '">' + sw(t) + '<span>' + esc(t.name) + '</span><em aria-hidden="true">×</em></button>'
                  : '<span class="nx-sheet__slot">' + sw(null) + '<span>' + (i + 1) + '</span></span>';
      }
      q('[data-sheet-picked]').innerHTML = '<div class="nx-sheet__slots">' + html + '</div><b class="nx-count' + (left ? '' : ' is-full') + '">' + st.picked.length + ' / ' + st.need + '</b>';
      el.querySelectorAll('[data-pick]').forEach(function (b) {
        var c = counts[b.getAttribute('data-pick')] || 0, n = b.querySelector('.nx-pick__n');
        b.classList.toggle('is-on', c > 0); b.setAttribute('aria-pressed', c ? 'true' : 'false');
        n.hidden = !c; n.textContent = c > 1 ? '×' + c : '✓';
      });
      var ok = q('[data-sheet-ok]');
      ok.disabled = left > 0;
      ok.textContent = left > 0 ? 'Faltan ' + left + (left === 1 ? ' color' : ' colores') : (st.o.confirm || 'Confirmar');
    }
    function close(done) {
      if (el.open) { if (el.close) el.close(); else el.removeAttribute('open'); }
      document.documentElement.classList.remove('nx-lock');
      var o = st.o; st.o = {};
      if (done && o.onDone) o.onDone(st.picked.map(function (n) { return d.byN[n]; }));
      else if (!done && o.onCancel) o.onCancel();
    }
    el.addEventListener('click', function (e) {
      if (e.target === el) return close(false);
      var p = e.target.closest('[data-pick]'), rm = e.target.closest('[data-sheet-rm]'), cat = e.target.closest('[data-sheet-cat]');
      if (p) {
        var n = p.getAttribute('data-pick');
        if (st.need === 1) st.picked = [n];
        else if (st.picked.length < st.need) st.picked.push(n);
        else { msg('Ya has elegido ' + st.need + ' colores: toca un color de arriba para quitarlo.'); return; }
        msg(''); render(); return;
      }
      if (rm) { st.picked.splice(+rm.getAttribute('data-sheet-rm'), 1); msg(''); render(); return; }
      if (cat) {
        var sec = q('[data-sheet-fam="' + cat.getAttribute('data-sheet-cat') + '"]');
        body.scrollTo({ top: sec.offsetTop - body.offsetTop - 6, behavior: 'smooth' });
      }
    });
    q('[data-sheet-x]').addEventListener('click', function () { close(false); });
    el.addEventListener('cancel', function (e) { e.preventDefault(); close(false); });
    q('[data-sheet-auto]').addEventListener('click', function () { st.picked = suggest(st.picked, st.need, st.o.avoid); msg(''); render(); });
    q('[data-sheet-ok]').addEventListener('click', function () { if (st.picked.length === st.need) close(true); });
    /* famiglia attiva mentre si scorre */
    var cats = el.querySelectorAll('[data-sheet-cat]'), nav = q('.nx-sheet__cats'), raf = 0, last = -1;
    body.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var top = body.scrollTop + 40, on = 0;
        el.querySelectorAll('[data-sheet-fam]').forEach(function (s, i) { if (s.offsetTop - body.offsetTop <= top) on = i; });
        if (on === last) return; last = on;
        cats.forEach(function (c, i) { c.classList.toggle('is-on', i === on); });
        if (nav.scrollWidth > nav.clientWidth) nav.scrollTo({ left: cats[on].offsetLeft - 16, behavior: 'smooth' });
      });
    }, { passive: true });
    SH = {
      open: function (o) {
        st.o = o || {}; st.need = Math.max(1, o.need || 1); last = -1;
        st.picked = (o.picked || []).map(function (t) { return t && t.n; }).filter(function (n) { return d.byN[n]; }).slice(0, st.need);
        var note = q('[data-sheet-note]'); note.hidden = !o.note; note.textContent = o.note || '';
        msg(''); render(); body.scrollTop = 0;
        cats.forEach(function (c, i) { c.classList.toggle('is-on', i === 0); }); nav.scrollLeft = 0;
        document.documentElement.classList.add('nx-lock');
        if (el.showModal) el.showModal(); else el.setAttribute('open', '');
      }
    };
    return SH;
  }
  function openSheet(o) { if (!tones().tones.length) return false; sheet().open(o); return true; }

  /* ---------- Colori in home/prodotto: famiglie a schede ---------- */
  function initColors(root) {
    if (!once(root, 'colors')) return;
    var tabs = root.querySelectorAll('[data-fam-tab]'), panels = root.querySelectorAll('[data-fam-panel]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-fam-tab');
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-fam-panel') !== i; });
      });
    });
  }

  /* ---------- Pagina prodotto ---------- */
  function initProduct(root) {
    if (!once(root, 'product')) return;
    var cfg = readJSON(root.querySelector('[data-nx-config]')); if (!cfg) return;
    var q = function (s) { return root.querySelector(s); }, qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var zoom = zoomer(root);

    /* Galleria a scorrimento con miniature */
    var track = q('[data-gal-track]'), slides = qa('.nx-gal__slide'), count = q('[data-gal-count]'), thumbsWrap = q('[data-gal-thumbs]'), cur = 0;
    if (slides.length) {
      slides.forEach(function (s, i) {
        var im = s.querySelector('img'); if (!im) return;
        var t = document.createElement('button'); t.type = 'button'; t.setAttribute('aria-label', 'Imagen ' + (i + 1)); t.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        t.innerHTML = '<img src="' + esc((im.currentSrc || im.src).replace(/width=\d+/, 'width=200')) + '" alt="" loading="lazy" width="100" height="100">';
        t.addEventListener('click', function () { go(i); });
        thumbsWrap.appendChild(t);
        im.addEventListener('click', function () { var src = im.currentSrc || im.src; zoom(src.replace(/width=\d+/, 'width=1800'), im.alt); });
      });
      if (slides.length < 2) { qa('[data-gal-prev],[data-gal-next]').forEach(function (b) { b.hidden = true; }); thumbsWrap.hidden = true; }
      count.textContent = '1 / ' + slides.length;
    }
    function go(i) { i = (i + slides.length) % slides.length; track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); }
    function sync() {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i === cur) return; cur = i;
      count.textContent = (i + 1) + ' / ' + slides.length;
      thumbsWrap.querySelectorAll('button').forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    var raf = 0; track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    q('[data-gal-prev]').addEventListener('click', function () { go(cur - 1); });
    q('[data-gal-next]').addEventListener('click', function () { go(cur + 1); });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); } });

    /* Stelline: solo se la sezione recensioni ha recensioni reali */
    var stats = readJSON(document.getElementById('naelis-review-stats')), rating = q('[data-rating]');
    if (stats && stats.count > 0 && rating) {
      q('[data-rating-stars]').innerHTML = starsHTML(stats.avg);
      q('[data-rating-text]').textContent = stats.avg.toFixed(1).replace('.', ',') + ' · ' + stats.count + (stats.count === 1 ? ' reseña' : ' reseñas');
      rating.hidden = false;
    }

    /* Scelta del set e dei colori */
    var params = new URLSearchParams(window.location.search), want = parseInt(params.get('bundle'), 10);
    var sel = cfg.variants[String(want)] ? want : (+cfg.def || 5), picked = [], busy = false;
    var cards = qa('[data-card]'), slots = q('[data-slots]'), openBtn = q('[data-open]');
    var cta = q('[data-add]'), ctaText = q('[data-add-text]'), err = q('[data-err]'), ship = q('[data-ship]'), cnt = q('[data-count]'), label = q('[data-pick-label]');
    var sticky = q('[data-sticky]'), sCta = q('[data-sticky-cta]'), sTitle = q('[data-sticky-title]'), sPrice = q('[data-sticky-price]');
    /* lampada a pagamento nei set sotto la soglia dell'omaggio (mai preselezionata) */
    var GL = cfg.gift, lampOn = false, lampBtns = qa('[data-lamp-toggle]');
    function lampCost() { return GL && lampOn && sel < GL.from ? (GL.addon || GL.price) : 0; }
    function v() { return cfg.variants[String(sel)] || {}; }
    function left() { return sel - picked.length; }
    function pl(n) { return n === 1 ? 'color' : 'colores'; }

    function render() {
      var vv = v(), ok = !!vv.id && !!vv.available, l = left(), free = sel >= cfg.freeFrom, html = '';
      cards.forEach(function (c) { var on = +c.getAttribute('data-card') === sel; c.classList.toggle('is-on', on); c.querySelector('input').checked = on; });
      for (var i = 0; i < sel; i++) {
        var t = picked[i];
        html += t ? '<button type="button" class="nx-slot is-filled" data-i="' + i + '" aria-label="' + esc(t.name) + ', bolígrafo ' + (i + 1) + ': toca para cambiar">' + sw(t, 'nx-sw--nail') + '<small>' + esc(t.name) + '</small></button>'
                  : '<button type="button" class="nx-slot" data-i="' + i + '" aria-label="Elige el color del bolígrafo ' + (i + 1) + '"><b>+</b><small>' + (i + 1) + '</small></button>';
      }
      slots.innerHTML = html;
      slots.setAttribute('data-n', sel);
      cnt.textContent = picked.length + ' / ' + sel; cnt.classList.toggle('is-full', l === 0);
      label.textContent = sel === 1 ? 'Elige tu color' : 'Elige tus ' + sel + ' colores';
      q('[data-open-text]').textContent = picked.length ? (l ? 'Elige ' + l + ' ' + pl(l) + ' más' : 'Cambia los colores') : 'Elige entre ' + (tones().tones.length || 48) + ' colores';
      openBtn.classList.toggle('is-done', l === 0);
      ship.textContent = free ? 'Envío gratis a España' : 'Envío calculado en el checkout'; ship.classList.toggle('no', !free);
      cta.disabled = busy || !ok;
      cta.classList.toggle('is-pending', ok && !busy && l > 0);
      var tot = (vv.price || 0) + lampCost();
      lampBtns.forEach(function (b) { b.setAttribute('aria-pressed', lampOn ? 'true' : 'false'); });
      ctaText.textContent = !ok ? 'No disponible' : busy ? 'Añadiendo al carrito…' : 'Añadir al carrito · ' + eur(tot);
      sTitle.textContent = cfg.name + ' · ' + sel + (sel === 1 ? ' bolígrafo' : ' bolígrafos') + (lampCost() ? ' + lámpara' : '');
      sPrice.innerHTML = eur(tot) + (vv.compare > vv.price ? '<s>' + eur(vv.compare) + '</s>' : '');
      sCta.disabled = busy || !ok;
      sCta.textContent = !ok ? 'No disponible' : l > 0 ? 'Elige los colores' : 'Añadir';
    }
    function pick() {
      err.textContent = '';
      var opened = openSheet({ need: sel, picked: picked, confirm: 'Confirmar ' + (sel === 1 ? 'el color' : 'los ' + sel + ' colores'),
        onDone: function (list) { picked = list; render(); if (innerWidth < 990) q('[data-buy]').scrollIntoView({ block: 'center', behavior: 'smooth' }); } });
      if (!opened) err.textContent = 'Los colores no se han cargado: recarga la página.';
    }
    cards.forEach(function (c) { c.querySelector('input').addEventListener('change', function () { sel = +c.getAttribute('data-card'); picked = picked.slice(0, sel); err.textContent = ''; render(); }); });
    slots.addEventListener('click', function (e) { if (e.target.closest('[data-i]')) pick(); });
    openBtn.addEventListener('click', pick);
    /* scelta rapida stagionale: riempie il set con i colori proposti, ripetendoli se servono */
    qa('[data-preset]').forEach(function (b) {
      var ns = b.getAttribute('data-preset').split(',').map(function (x) { return x.trim(); }).filter(function (n) { return tones().byN[n]; });
      if (!ns.length) { b.hidden = true; return; }
      var dots = b.querySelector('[data-preset-dots]'); if (dots) dots.innerHTML = ns.slice(0, 3).map(function (n) { return sw(tones().byN[n]); }).join('');
      b.addEventListener('click', function () {
        picked = []; for (var i = 0; i < sel; i++) picked.push(tones().byN[ns[i % ns.length]]);
        err.textContent = ''; render();
        if (innerWidth < 990) q('[data-buy]').scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
    });
    lampBtns.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); lampOn = !lampOn; render(); }); });
    qa('[data-lamp-switch]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); var n = +b.getAttribute('data-lamp-switch'); if (!cfg.variants[String(n)]) return;
        sel = n; err.textContent = ''; render();
        var c = cards.filter(function (x) { return +x.getAttribute('data-card') === n; })[0];
        if (c) { c.querySelector('input').focus({ preventScroll: true }); c.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
      });
    });

    function add() {
      if (busy) return; var vv = v(); if (!vv.id || !vv.available) return;
      if (left() > 0) { pick(); return; }
      var props = {}; picked.forEach(function (t, i) { props['Color ' + (i + 1)] = t.label; });
      busy = true; err.textContent = ''; render();
      var items = penItems(String(sel), picked.map(function (t) { return t.n; }), newSid()) || [{ id: vv.id, quantity: 1, properties: props }];
      if (cfg.gift && cfg.gift.id && sel >= cfg.gift.from) items.push({ id: cfg.gift.id, quantity: 1, properties: { _gift: '1' } });
      else if (lampCost()) items.push({ id: GL.id, quantity: 1 });
      fetch(cfg.add, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'inténtalo de nuevo'); window.location.assign(cfg.cart); }); })
        .catch(function (e) { busy = false; err.textContent = 'No hemos podido añadir el set: ' + (e.message || 'inténtalo de nuevo') + '.'; render(); });
    }
    cta.addEventListener('click', add);
    sCta.addEventListener('click', add);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0], on = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); sCta.tabIndex = on ? 0 : -1;
      }).observe(q('[data-buy]'));
    }
    render();
  }

  /* ---------- Recensioni ---------- */
  function initReviews(root) {
    if (!once(root, 'reviews')) return;
    var list = root.querySelector('[data-list]'); if (!list) return;
    var items = Array.prototype.slice.call(list.children), per = +root.getAttribute('data-per') || 5, shown = per, filter = 'all';
    var more = root.querySelector('[data-more]'), showing = root.querySelector('[data-showing]'), ctrls = root.querySelectorAll('[data-filter]');
    var zoom = zoomer(root);
    function apply() {
      var match = items.filter(function (li) { return filter === 'all' || (filter === 'photo' ? li.getAttribute('data-photo') === '1' : li.getAttribute('data-rating') === filter); });
      items.forEach(function (li) { li.hidden = true; });
      match.forEach(function (li, i) { li.hidden = i >= shown; });
      var vis = Math.min(shown, match.length), rest = match.length - vis;
      more.hidden = rest <= 0; if (rest > 0) more.textContent = 'Ver más reseñas (' + rest + ')';
      showing.textContent = match.length ? vis + ' de ' + match.length : '';
      ctrls.forEach(function (c) { var on = c.getAttribute('data-filter') === filter; c.classList.toggle('is-on', on); if (c.hasAttribute('aria-pressed')) c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    }
    ctrls.forEach(function (c) { c.addEventListener('click', function () { var f = c.getAttribute('data-filter'); filter = (filter === f && f !== 'all') ? 'all' : f; shown = per; apply(); }); });
    more.addEventListener('click', function () { shown += per; apply(); });
    root.querySelectorAll('[data-zoom-src]').forEach(function (b) { b.addEventListener('click', function () { zoom(b.getAttribute('data-zoom-src'), 'Foto de la reseña'); }); });
    apply();
  }

  /* ---------- Carrello ---------- */
  function initCart(root) {
    if (!once(root, 'cart')) return;
    var cfg = readJSON(root.querySelector('[data-nx-cart-config]')); if (!cfg) return;
    var base = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
    var q = function (s) { return root.querySelector(s); };
    var cart = null, busy = false, note = '', noteOk = false;
    var ad = cfg.addon || {};
    var qtyOf = {}; [[cfg.v1, 1], [cfg.v3, 3], [cfg.v5, 5], [cfg.v5u, 5], [cfg.v10, 10]].forEach(function (x) { if (x[0]) qtyOf[x[0]] = x[1]; });
    /* varianti a prezzo carrello: una sola per ordine, quantità fissa a 1 */
    function isDeal(it) { return (cfg.v5u && it.variant_id === cfg.v5u) || (cfg.v10 && it.variant_id === cfg.v10); }
    var addOf = {}; if (ad.v1) addOf[ad.v1] = 1; if (ad.v2) addOf[ad.v2] = 2;
    var P = pens(), G = cfg.gift || null, giftBroken = false;
    function isGift(it) { return !!(G && it.variant_id === G.id && it.properties && it.properties._gift); }
    function isLamp(it) { return !!(G && it.variant_id === G.id && !isGift(it)); }
    var SP = cfg.spare && cfg.spare.id ? cfg.spare : null;
    function isSpare(it) { return !!(SP && it.variant_id === SP.id); }
    var KIT = cfg.kit && cfg.kit.id ? cfg.kit : null;
    function isKit(it) { return !!(KIT && it.variant_id === KIT.id); }
    var OIL = cfg.oil && cfg.oil.id ? cfg.oil : null;
    function isOil(it) { return !!(OIL && it.variant_id === OIL.id); }
    var PRO = cfg.protect && cfg.protect.id ? cfg.protect : null;
    function isPro(it) { return !!(PRO && it.variant_id === PRO.id); }
    function offerLow() { var o = cfg.offer || 'Oferta de lanzamiento'; return o.charAt(0).toLowerCase() + o.slice(1); }
    function cureTxt() { return G && G.cure ? G.cure : '60 secondi'; }
    function compOf(it) { return P.byV[it.variant_id] || null; }
    function isPen(it) { return !!qtyOf[it.variant_id] || !!compOf(it); }
    /* righe per colore raggruppate per set (_set); ok = set completo */
    function groupsOf(items) {
      var m = {}, order = [];
      items.forEach(function (it) {
        var c = compOf(it); if (!c) return;
        var sid = (it.properties && it.properties._set) || 'x', id = sid + '|' + c.tier, g = m[id];
        if (!g) { g = m[id] = { sid: sid, tier: c.tier, size: (P.tiers[c.tier] || {}).size || 0, lines: [], colors: [], total: 0 }; order.push(g); }
        g.lines.push(it); for (var i = 0; i < it.quantity; i++) g.colors.push(c.n); g.total += it.final_line_price;
      });
      order.forEach(function (g) { g.ok = g.size > 0 && g.colors.length === g.size; });
      return order;
    }
    function isAdd(it) { return !!addOf[it.variant_id]; }
    function api(path, body) {
      return fetch(base + path, body ? { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) } : { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Se ha producido un error'); return d; }); });
    }
    function load() { return api('cart.js').then(function (c) { cart = c; return c; }); }
    function alertMsg() { var a = q('[data-alert]'); a.hidden = !note; a.textContent = note; a.classList.toggle('is-ok', noteOk); }
    /* valori "Colore N" della riga, nell'ordine */
    function tonesOf(it) {
      var p = it.properties || {};
      return Object.keys(p).filter(function (k) { return /^Colore?\s*\d+$/i.test(k) && p[k]; })
        .sort(function (x, y) { return parseInt(x.replace(/\D/g, ''), 10) - parseInt(y.replace(/\D/g, ''), 10); })
        .map(function (k) { return p[k]; });
    }
    function props(values, extra) { var o = {}; values.forEach(function (t, i) { o['Color ' + (i + 1)] = t; }); if (extra) Object.keys(extra).forEach(function (k) { o[k] = extra[k]; }); return o; }
    /* pulizia: vecchia lampada UV e penne in più rimaste senza un set */
    /* omaggio: c'è un set che lo dà diritto? */
    function qualifies(items) {
      if (!G) return false;
      return groupsOf(items).some(function (g) { return g.ok && g.size >= G.from; }) || items.some(function (i) { return (qtyOf[i.variant_id] || 0) >= G.from; });
    }
    /* aggiunge o toglie la lampada in omaggio; se Shopify non la sconta (sconto spento), la toglie e non la ripropone */
    function syncGift() {
      if (!G || !cart) return Promise.resolve();
      var gifts = cart.items.filter(isGift), q = !giftBroken && qualifies(cart.items), up = {}, n = 0;
      gifts.forEach(function (g, i) { var want = q && i === 0 ? 1 : 0; if (g.quantity !== want) { up[g.key] = want; n++; } });
      /* lampada pagata + set che dà l'omaggio: la pagata si toglie, arriva quella gratis */
      var paidLamps = q ? cart.items.filter(isLamp) : [];
      paidLamps.forEach(function (l) { up[l.key] = 0; n++; });
      if (paidLamps.length) { note = (note ? note + ' ' : '') + 'Ahora la lámpara es de regalo: la hemos quitado de la cuenta.'; noteOk = true; }
      var job = n ? api('cart/update.js', { updates: up }).then(function (c) { cart = c; }) : Promise.resolve();
      if (q && !gifts.length) job = job.then(function () { return api('cart/add.js', { items: [{ id: G.id, quantity: 1, properties: { _gift: '1' } }] }); }).then(load);
      return job.then(function () {
        var paid = cart.items.filter(function (i) { return isGift(i) && i.final_line_price > 0; });
        if (!paid.length) return;
        giftBroken = true; var u2 = {}; paid.forEach(function (i) { u2[i.key] = 0; });
        return api('cart/update.js', { updates: u2 }).then(function (c) { cart = c; });
      }).catch(function () {});
    }
    function cleanup() { return cleanupBase().then(syncGift); }
    function cleanupBase() {
      if (!cart) return Promise.resolve();
      var bad = cart.items.filter(function (i) { return (cfg.remove && i.variant_id === cfg.remove) || (isAdd(i) && !cart.items.some(isPen)); });
      var noSet = !qualifies(cart.items.filter(function (i) { return !isSpare(i); }));
      bad = bad.concat(cart.items.filter(function (i) { return isSpare(i) && noSet; }));
      var noPen = !cart.items.some(isPen);
      bad = bad.concat(cart.items.filter(function (i) { return (isKit(i) || isOil(i)) && noPen; }));
      var onlyPro = !cart.items.some(function (i) { return !isPro(i); });
      bad = bad.concat(cart.items.filter(function (i) { return isPro(i) && onlyPro; }));
      var many = cart.items.filter(function (i) { return (isDeal(i) || isSpare(i) || isKit(i) || isOil(i) || isPro(i)) && i.quantity > 1 && bad.indexOf(i) < 0; });
      groupsOf(cart.items).forEach(function (g) { if (!g.ok) bad = bad.concat(g.lines); });
      if (!bad.length && !many.length) return Promise.resolve();
      var up = {}; bad.forEach(function (i) { up[i.key] = 0; }); many.forEach(function (i) { up[i.key] = 1; });
      return api('cart/update.js', { updates: up }).then(function (c) {
        cart = c; noteOk = true;
        note = bad.some(isOil) ? 'El bolígrafo para cutículas se añade junto con los bolígrafos: lo hemos quitado.' : bad.some(isPro) ? '' : bad.some(isKit) ? 'El Kit Cambio de Color se añade junto con los bolígrafos: lo hemos quitado.' : bad.some(isSpare) ? 'La lámpara de repuesto a precio de carrito va con un set de ' + (G ? G.from : 3) + ' bolígrafos: la hemos quitado.' : many.length ? 'El precio de carrito vale para un set por pedido.' : bad.some(compOf) ? 'Hemos quitado un set incompleto: puedes volver a crearlo desde la página del producto.' : bad.some(isAdd) ? 'Los bolígrafos extra solo se añaden junto con un set: los hemos quitado del carrito.' : 'Hemos quitado del carrito un artículo que ya no está disponible.';
      });
    }
    function toneChips(values) {
      if (!values.length) return '';
      var counts = {}, order = [];
      values.forEach(function (v) { if (!counts[v]) { counts[v] = 0; order.push(v); } counts[v]++; });
      return '<div class="nx-line__tones">' + order.map(function (v) {
        var t = toneOf(v);
        return '<span>' + sw(t) + esc(t ? t.name : v) + (t ? ' <small>' + esc(t.n) + '</small>' : '') + (counts[v] > 1 ? ' <em>×' + counts[v] + '</em>' : '') + '</span>';
      }).join('') + '</div>';
    }
    function line(it) {
      var li = document.createElement('article'); li.className = 'nx-line';
      var pen = isPen(it), extra = isAdd(it), n = qtyOf[it.variant_id] || addOf[it.variant_id] || 0;
      var img = it.image ? it.image.replace(/(\.[a-z0-9]+)(\?.*)?$/i, '_240x240$1') : cfg.fallbackImg;
      var other = Object.keys(it.properties || {}).filter(function (k) { var v = it.properties[k]; return v !== null && v !== '' && k.charAt(0) !== '_' && !/^Colore?\s*\d+$/i.test(k); })
        .map(function (k) { return '<p class="nx-line__props">' + esc(k) + ': ' + esc(it.properties[k]) + '</p>'; }).join('');
      var title = pen ? 'Glossy Pen' : (extra ? (n === 1 ? 'Bolígrafo extra' : n + ' bolígrafos extra') : it.product_title);
      var meta = pen ? (n + (n === 1 ? ' bolígrafo' : ' bolígrafos') + (n > 1 ? ' · ' + eur(Math.round(it.final_price / n)) + ' por bolígrafo' : '') + (isDeal(it) ? ' · precio de carrito' : ''))
        : extra ? 'Añadido a tu set · ' + eur(Math.round(it.final_price / n)) + ' por bolígrafo'
        : (it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) : '');
      var was = it.original_line_price > it.final_line_price ? '<s>' + eur(it.original_line_price) + '</s>'
        : (cfg.v5u && it.variant_id === cfg.v5u && cfg.p5 > it.final_price ? '<s>' + eur(cfg.p5) + '</s>' : '');
      var qty = extra || isDeal(it) ? '<span class="nx-line__fixed">Cantidad 1</span>' : '<div class="nx-qtyctl"><button type="button" data-q="' + (it.quantity - 1) + '" aria-label="Reducir cantidad">−</button><span>' + it.quantity + '</span><button type="button" data-q="' + (it.quantity + 1) + '" aria-label="Aumentar cantidad">+</button></div>';
      li.innerHTML = '<div class="nx-line__img"><img src="' + esc(img) + '" alt="" loading="lazy" width="104" height="104"></div>' +
        '<div><h3 class="nx-line__title"><a href="' + esc(pen || extra ? cfg.productUrl : (it.url || cfg.productUrl)) + '">' + esc(title) + '</a></h3>' +
        (meta ? '<p class="nx-line__meta">' + meta + '</p>' : '') + toneChips(tonesOf(it)) + other + '</div>' +
        '<div class="nx-line__price"><strong>' + eur(it.final_line_price) + '</strong>' + was + '</div>' +
        '<div class="nx-line__actions">' + qty + '<button type="button" class="nx-line__rm" data-q="0">Eliminar</button></div>';
      li.querySelectorAll('[data-q]').forEach(function (b) { b.addEventListener('click', function () { change(it.key, +b.getAttribute('data-q'), li); }); });
      return li;
    }

    function groupLine(g) {
      var li = document.createElement('article'); li.className = 'nx-line';
      var per = Math.round(g.total / g.size), full = P.tiers['5'] ? P.tiers['5'].price * 5 : 0;
      var meta = g.size + (g.size === 1 ? ' bolígrafo' : ' bolígrafos') + (g.size > 1 ? ' · ' + eur(per) + ' por bolígrafo' : '') + (g.tier === '5u' ? ' · precio de carrito' : '');
      var was = g.tier === '5u' && full > g.total ? '<s>' + eur(full) + '</s>' : '';
      var vals = g.colors.map(function (n) { var t = tones().byN[n]; return t ? t.label : n; });
      li.innerHTML = '<div class="nx-line__img"><img src="' + esc(cfg.fallbackImg) + '?width=240" alt="" loading="lazy" width="104" height="104"></div>' +
        '<div><h3 class="nx-line__title"><a href="' + esc(cfg.productUrl) + '">Glossy Pen</a></h3><p class="nx-line__meta">' + meta + '</p>' + toneChips(vals) + '</div>' +
        '<div class="nx-line__price"><strong>' + eur(g.total) + '</strong>' + was + '</div>' +
        '<div class="nx-line__actions"><span class="nx-line__fixed">' + (g.size === 1 ? '1 bolígrafo' : 'Set de ' + g.size) + '</span><button type="button" class="nx-line__rm" data-rm>Eliminar</button></div>';
      li.querySelector('[data-rm]').addEventListener('click', function () { drop(g.lines.map(function (l) { return l.key; }), li); });
      return li;
    }
    function kitLine(it) {
      var li = document.createElement('article'); li.className = 'nx-line nx-line--kit';
      li.innerHTML = '<div class="nx-line__img"><img src="' + esc(KIT.img || it.image || cfg.fallbackImg) + '" alt="" loading="lazy" width="104" height="104"></div>' +
        '<div><h3 class="nx-line__title">Kit Cambio de Color</h3><p class="nx-line__meta">10 pinzas para retirar el esmalte, empujador de cutículas y lima 100/180</p></div>' +
        '<div class="nx-line__price"><strong>' + eur(it.final_line_price) + '</strong>' + (KIT.compare > it.final_price ? '<s>' + eur(KIT.compare) + '</s>' : '') + '</div>' +
        '<div class="nx-line__actions"><span class="nx-line__fixed">Cantidad 1</span><button type="button" class="nx-line__rm" data-rm>Eliminar</button></div>';
      li.querySelector('[data-rm]').addEventListener('click', function () { change(it.key, 0, li); });
      return li;
    }
    function oilLine(it) {
      var li = document.createElement('article'); li.className = 'nx-line nx-line--kit';
      li.innerHTML = '<div class="nx-line__img"><img src="' + esc(OIL.img || it.image || cfg.fallbackImg) + '" alt="" loading="lazy" width="104" height="104"></div>' +
        '<div><h3 class="nx-line__title">Aceite para cutículas en bolígrafo</h3><p class="nx-line__meta">Aceite de lavanda y punta empuja-cutículas</p></div>' +
        '<div class="nx-line__price"><strong>' + eur(it.final_line_price) + '</strong>' + (OIL.compare > it.final_price ? '<s>' + eur(OIL.compare) + '</s>' : '') + '</div>' +
        '<div class="nx-line__actions"><span class="nx-line__fixed">Cantidad 1</span><button type="button" class="nx-line__rm" data-rm>Eliminar</button></div>';
      li.querySelector('[data-rm]').addEventListener('click', function () { change(it.key, 0, li); });
      return li;
    }
    var barIO = null;
    function renderProtect(items) {
      var box = q('[data-protect]'), bar = q('[data-protect-bar]'); if (!box) return;
      var others = items.filter(function (i) { return !isPro(i); });
      if (!PRO || !others.length) { box.hidden = true; box.innerHTML = ''; if (bar) { bar.hidden = true; bar.innerHTML = ''; } return; }
      var cur = items.filter(isPro)[0], on = cur ? ' is-on' : '', ck = cur ? ' checked' : '', pr = (cur ? '' : '+') + eur(PRO.price);
      box.hidden = false;
      box.innerHTML = '<label class="nx-sumpr' + on + '"><span class="nx-sumpr__ic"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7 3v5c0 4.6-3 8.4-7 10-4-1.6-7-5.4-7-10V6l7-3z"/><path d="M9 12l2 2 4-4" stroke-linecap="round"/></svg></span>' +
        '<span class="nx-sumpr__txt"><b>Protege tu paquete</b><small>Si se pierde o se daña, te lo reenviamos ya.</small></span>' +
        '<span class="nx-sumpr__p">' + pr + '</span><input type="checkbox" class="nx-sumpr__cb" data-toggle' + ck + ' aria-label="Protege tu paquete, ' + eur(PRO.price) + '"></label>';
      if (bar) {
        bar.hidden = false;
        bar.innerHTML = '<label class="nx-barpr' + on + '"><input type="checkbox" class="nx-sumpr__cb" data-toggle' + ck + ' aria-label="Protege tu paquete, ' + eur(PRO.price) + '"><span><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7 3v5c0 4.6-3 8.4-7 10-4-1.6-7-5.4-7-10V6l7-3z"/><path d="M9 12l2 2 4-4" stroke-linecap="round"/></svg> Protege el paquete</span><em>' + pr + '</em></label>';
      }
      [].forEach.call(document.querySelectorAll('[data-protect] [data-toggle], [data-protect-bar] [data-toggle]'), function (tg) {
        tg.addEventListener('change', function () {
          if (busy) { tg.checked = !tg.checked; return; }
          if (!tg.checked) { if (cur) change(cur.key, 0); return; }
          busy = true; note = ''; render();
          api('cart/add.js', { items: [{ id: PRO.id, quantity: 1, properties: { _protect: '1' } }] }).then(load).then(cleanup)
            .then(function () { note = 'Paquete protegido.'; noteOk = true; })
            .catch(function (e) { note = e.message; noteOk = false; return load(); })
            .then(function () { busy = false; render(); });
        });
      });
      if (!barIO && 'IntersectionObserver' in window && q('[data-checkout]') && q('[data-bar]')) {
        barIO = new IntersectionObserver(function (en) { q('[data-bar]').classList.toggle('is-away', en[0].isIntersecting); });
        barIO.observe(q('[data-checkout]'));
      }
    }
    function spareLine(it) {
      var li = document.createElement('article'); li.className = 'nx-line nx-line--lamp';
      li.innerHTML = '<div class="nx-line__img"><img src="' + esc(G.img || it.image || cfg.fallbackImg) + '" alt="" loading="lazy" width="104" height="104"></div>' +
        '<div><h3 class="nx-line__title">Lámpara UV LED de repuesto</h3><p class="nx-line__meta">Precio de carrito, solo junto con el set</p></div>' +
        '<div class="nx-line__price"><strong>' + eur(it.final_line_price) + '</strong>' + (G.price > it.final_price ? '<s>' + eur(G.price) + '</s>' : '') + '</div>' +
        '<div class="nx-line__actions"><span class="nx-line__fixed">Cantidad 1</span><button type="button" class="nx-line__rm" data-rm>Eliminar</button></div>';
      li.querySelector('[data-rm]').addEventListener('click', function () { change(it.key, 0, li); });
      return li;
    }
    function lampLine(it) {
      var li = document.createElement('article'); li.className = 'nx-line nx-line--lamp';
      var was = it.original_line_price > it.final_line_price ? '<s>' + eur(it.original_line_price) + '</s>' : '';
      li.innerHTML = '<div class="nx-line__img"><img src="' + esc(G.img || it.image || cfg.fallbackImg) + '" alt="" loading="lazy" width="104" height="104"></div>' +
        '<div><h3 class="nx-line__title">' + esc(G.title || it.product_title) + (it.quantity > 1 ? ' × ' + it.quantity : '') + '</h3><p class="nx-line__meta">Fija el color: ' + esc(cureTxt()) + ' por cada capa</p></div>' +
        '<div class="nx-line__price"><strong>' + eur(it.final_line_price) + '</strong>' + was + '</div>' +
        '<div class="nx-line__actions"><span class="nx-line__fixed">' + (giftBroken ? 'Lámpara' : 'Gratis desde el set de ' + G.from + ' bolígrafos') + '</span><button type="button" class="nx-line__rm" data-rm>Eliminar</button></div>';
      li.querySelector('[data-rm]').addEventListener('click', function () { change(it.key, 0, li); });
      return li;
    }
    /* frase sulla lampada quando un upgrade porta il set sopra la soglia dell'omaggio */
    function lampUpg(o, fromSize) {
      if (!G || giftBroken || o.n < G.from || fromSize >= G.from) return '';
      var paid = cart.items.filter(isLamp).reduce(function (a, l) { return a + l.final_line_price; }, 0);
      if (!paid) return ' Y además, la <b>lámpara UV LED de regalo</b>.';
      var net = o.delta - paid;
      return ' Y la lámpara que has añadido pasa a ser <b>de regalo</b>: ' + (net < 0 ? 'al final pagas <b>' + eur(-net) + ' menos</b> que ahora.' : net === 0 ? 'el total no cambia.' : 'el total solo sube <b>' + eur(net) + '</b>.');
    }
    function giftLine(it) {
      var li = document.createElement('article'); li.className = 'nx-line nx-line--gift';
      li.innerHTML = '<div class="nx-line__img"><img src="' + esc(G.img || it.image || cfg.fallbackImg) + '" alt="" loading="lazy" width="104" height="104"></div>' +
        '<div><h3 class="nx-line__title">' + esc(G.title || it.product_title) + '</h3><p class="nx-line__meta">De regalo con la ' + esc(offerLow()) + ' · fija cada capa en ' + esc(cureTxt()) + '</p></div>' +
        '<div class="nx-line__price"><strong>' + (it.final_line_price > 0 ? eur(it.final_line_price) : 'Gratis') + '</strong><s>' + eur(G.price) + '</s></div>' +
        '<div class="nx-line__actions"><span class="nx-line__fixed">Omaggio · si toglie da solo se cambi set</span></div>';
      return li;
    }
    function drop(keys, el) {
      if (busy) return; busy = true; note = ''; if (el) el.classList.add('is-busy');
      var up = {}; keys.forEach(function (k) { up[k] = 0; });
      api('cart/update.js', { updates: up }).then(function (c) { cart = c; return cleanup(); })
        .catch(function (e) { note = 'No hemos podido actualizar el carrito: ' + e.message + '.'; noteOk = false; return load(); })
        .then(function () { busy = false; render(); });
    }

    /* ----- Upsell a interruttore: accendi → scegli i colori nel pannello → aggiunto ----- */
    function names(values) { return values.map(function (v) { var t = toneOf(v); return t ? t.name : v; }); }
    function priceOf(o) { return o.delta ? '+' + eur(o.delta) : eur(o.price); }
    function lineOf(items, v) { return v ? items.filter(function (i) { return i.variant_id === v; })[0] : null; }
    /* Passaggio al set più grande: 1 → 3, 3 → 5 (prezzo carrello), 5 → 10 */
    function upgradeGroup(gs) {
      var T = P.tiers, find = function (k) { return gs.filter(function (g) { return g.tier === k; })[0]; };
      var g1 = find('1'), g3 = find('3'), g5 = find('5') || find('5u'), g10 = find('10'), o = null;
      var free = cfg.free || 0, total = cart.total_price || 0, full5 = T['5'] ? T['5'].price * 5 : 0;
      if (g10) return null;
      if (g5 && T['10'] && T['10'].ok) o = { g: g5, to: '10', n: 10, add: 5, tag: 'Solo en el carrito', img: cfg.palImg };
      else if (g3 && T['5u'] && T['5u'].ok) o = { g: g3, to: '5u', n: 5, add: 2, tag: 'Solo en el carrito', img: cfg.setImg };
      else if (g1 && T['3'] && T['3'].ok) o = { g: g1, to: '3', n: 3, add: 2, tag: cfg.offer || 'Precio de lanzamiento', img: cfg.setImg };
      if (!o) return null;
      o.delta = T[o.to].price * o.n - o.g.total; if (o.delta <= 0) return null;
      if (o.to === '5u' && full5 - o.g.total > o.delta) o.reg = full5 - o.g.total;
      o.keep = o.g.colors.map(function (n) { var t = tones().byN[n]; return t ? t.label : n; }); o.need = o.add;
      var per = Math.round(o.delta / o.add), newPer = Math.round((o.g.total + o.delta) / o.n);
      o.title = 'Pasa a ' + o.n + ' bolígrafos';
      o.sub = o.add + ' bolígrafos más a <b>' + eur(per) + ' cada uno</b>: el set de ' + o.n + ' te sale a ' + eur(newPer) + ' por bolígrafo' + (free && total < free && total + o.delta >= free ? ' y el <b>envío pasa a ser gratis</b>' : '') + '.';
      o.sub += lampUpg(o, o.g.size);
      o.fine = o.reg ? 'En la web el set de 5 cuesta ' + eur(full5) + ': este precio solo vale aquí en el carrito.' : (o.n === 10 ? 'El set de 10 no está a la venta en la web: solo lo encuentras aquí en el carrito.' : 'Elige los colores extra; los que ya tienes se mantienen.');
      return o;
    }
    function upgrade(items) {
      var gs = groupsOf(items).filter(function (g) { return g.ok; });
      if (gs.length) return upgradeGroup(gs);
      var one = lineOf(items, cfg.v1), three = lineOf(items, cfg.v3), five = lineOf(items, cfg.v5) || lineOf(items, cfg.v5u), ten = lineOf(items, cfg.v10);
      var free = cfg.free || 0, total = cart.total_price || 0;
      function shipTxt(delta) { return free && total < free && total + delta >= free ? ' y el <b>envío pasa a ser gratis</b>' : ''; }
      var o = null;
      if (ten) return null;
      if (five && five.quantity === 1 && cfg.v10 && cfg.p10 > five.price) {
        o = { from: five, to: cfg.v10, n: 10, add: 5, delta: cfg.p10 - five.price, tag: 'Solo en el carrito', img: cfg.palImg };
      } else if (!five && three && three.quantity === 1 && cfg.v5u && cfg.p5u > cfg.p3) {
        o = { from: three, to: cfg.v5u, n: 5, add: 2, delta: cfg.p5u - cfg.p3, reg: cfg.p5 > cfg.p5u ? cfg.p5 - cfg.p3 : 0, tag: 'Solo en el carrito', img: cfg.setImg };
      } else if (!five && !three && one && one.quantity === 1 && cfg.v3 && cfg.p3 > cfg.p1) {
        o = { from: one, to: cfg.v3, n: 3, add: 2, delta: cfg.p3 - cfg.p1, tag: cfg.offer || 'Precio de lanzamiento', img: cfg.setImg };
      }
      if (!o) return null;
      o.keep = tonesOf(o.from); o.need = o.add;
      var per = Math.round(o.delta / o.add), newPer = Math.round((o.from.price + o.delta) / o.n);
      o.title = 'Pasa a ' + o.n + ' bolígrafos';
      o.sub = o.add + ' bolígrafos más a <b>' + eur(per) + ' cada uno</b>: el set de ' + o.n + ' te sale a ' + eur(newPer) + ' por bolígrafo' + shipTxt(o.delta) + '.';
      o.sub += lampUpg(o, qtyOf[o.from.variant_id] || 0);
      o.fine = o.reg ? 'En la web el set de ' + o.n + ' cuesta ' + eur(cfg.p5) + ': este precio solo vale aquí en el carrito.' : (o.n === 10 ? 'El set de 10 no está a la venta en la web: solo lo encuentras aquí en el carrito.' : 'Elige los colores extra; los que ya tienes se mantienen.');
      return o;
    }
    function renderUpgrade(items) {
      var box = q('[data-upgrade]'), o = upgrade(items);
      if (!o) { box.innerHTML = ''; return; }
      box.innerHTML = '<div class="nx-upg"><span class="nx-upg__tag">' + esc(o.tag) + '</span>' +
        '<div class="nx-upg__row"><span class="nx-upg__img"><img src="' + esc(o.img || cfg.fallbackImg) + '?width=200" alt="" width="76" height="76" loading="lazy"></span>' +
        '<div><h2>' + esc(o.title) + '</h2><p class="nx-upg__sub">' + o.sub + '</p></div>' +
        '<div class="nx-upg__price"><strong>+' + eur(o.delta) + '</strong>' + (o.reg ? '<s>+' + eur(o.reg) + '</s>' : '') + '</div></div>' +
        '<button type="button" class="nx-btn nx-btn--block" data-upg>Sí, paso a ' + o.n + ' bolígrafos · +' + eur(o.delta) + '</button>' +
        '<p class="nx-upg__fine">' + esc(o.fine) + '</p></div>';
      box.querySelector('[data-upg]').addEventListener('click', function () {
        if (busy) return;
        var opened = openSheet({
          need: o.need, avoid: o.keep.map(toneOf).filter(Boolean).map(function (t) { return t.n; }),
          title: 'Elige los ' + o.need + ' bolígrafos extra',
          note: o.keep.length ? 'Se añaden a: ' + names(o.keep).join(', ') + '.' : '',
          confirm: 'Pasa a ' + o.n + ' bolígrafos · +' + eur(o.delta),
          onDone: function (list) { apply(o, list.map(function (t) { return t.label; })); }
        });
        if (!opened) { note = 'Los colores no se han cargado: recarga la página.'; noteOk = false; alertMsg(); }
      });
    }
    /* Penne in più (prodotto separato, opzionale) */
    function offers(items) {
      var big = items.filter(function (i) { return qtyOf[i.variant_id] >= 5; })[0] || groupsOf(items).filter(function (g) { return g.ok && g.size >= 5; })[0];
      var addLine = items.filter(isAdd)[0], list = [];
      if (big && ad.v1) {
        [1, 2].forEach(function (n) {
          var v = ad['v' + n], pr = ad['p' + n]; if (!v || !pr) return;
          list.push({ k: 'add' + n, need: n, add: v, price: pr, on: !!(addLine && addLine.variant_id === v), cur: addLine,
            title: n === 1 ? '+1 bolígrafo' : '+2 bolígrafos', sub: eur(Math.round(pr / n)) + ' por bolígrafo, solo junto con el set · suelto ' + eur(cfg.p1), img: cfg.penImg });
        });
      }
      return list;
    }
    /* lampada da aggiungere: carrello con penne ma senza set che dà l'omaggio */
    /* Completa il kit: Kit Cambio Colore (con qualsiasi penna) + lampada di scorta (solo con un set che dà l'omaggio) */
    function renderLampUps(items) {
      var box = q('[data-upsell]'), list = [];
      if (KIT && items.some(isPen)) {
        var kc = items.filter(isKit)[0];
        list.push({ k: 'kit', id: KIT.id, price: KIT.price, cur: kc, img: KIT.img || cfg.fallbackImg, props: { _kit: '1' },
          title: 'Kit Cambio de Color', sub: '10 pinzas, empujador de cutículas y lima: para quitar el color y pasar al siguiente sin esfuerzo', was: KIT.compare || 0 });
      }
      if (OIL && items.some(isPen)) {
        var oc = items.filter(isOil)[0];
        list.push({ k: 'oil', id: OIL.id, price: OIL.price, cur: oc, img: OIL.img || cfg.fallbackImg, props: { _oil: '1' },
          title: 'Aceite para cutículas en bolígrafo', sub: 'Bolígrafo 2 en 1 con aceite de lavanda y punta para empujar la cutícula', was: OIL.compare || 0 });
      }
      if (!list.length) return false;
      box.hidden = false;
      box.innerHTML = '<div class="nx-ups__head"><span class="nx-eyebrow">Solo en el carrito</span><h2>Completa tu <em>kit.</em></h2>' +
        '<p>El color lo aplicas con el bolígrafo y lo fijas con la lámpara. Para cambiarlo necesitas el resto: aquí lo añades con un toque.</p></div>' +
        list.map(function (o) {
          return '<div class="nx-ups__item' + (o.cur ? ' is-on' : '') + '" data-k="' + o.k + '"><label class="nx-ups__row"><span class="nx-ups__img"><img src="' + esc(o.img) + '" alt="" width="64" height="64" loading="lazy"></span>' +
            '<span class="nx-ups__txt"><strong>' + esc(o.title) + '</strong><small>' + esc(o.sub) + '</small></span>' +
            '<span class="nx-ups__price">' + eur(o.price) + (o.was > o.price ? ' <s style="margin-left:4px;font-size:12.5px;font-weight:400;color:var(--nx-soft)">' + eur(o.was) + '</s>' : '') + '</span>' +
            '<input type="checkbox" class="nx-switch" role="switch" data-toggle' + (o.cur ? ' checked' : '') + ' aria-label="Añadir ' + esc(o.title) + ', ' + eur(o.price) + '"></label></div>';
        }).join('');
      list.forEach(function (o) {
        var tg = box.querySelector('[data-k="' + o.k + '"] [data-toggle]');
        tg.addEventListener('change', function () {
          if (busy) { tg.checked = !tg.checked; return; }
          if (!tg.checked) { if (o.cur) change(o.cur.key, 0); return; }
          busy = true; note = ''; render();
          api('cart/add.js', { items: [{ id: o.id, quantity: 1, properties: o.props }] }).then(load).then(cleanup)
            .then(function () { note = o.title + ' añadido.'; if (o.k === 'spare') note = 'Lámpara de repuesto añadida.'; noteOk = true; })
            .catch(function (e) { note = 'No hemos podido añadirlo: ' + e.message + '.'; noteOk = false; return load(); })
            .then(function () { busy = false; render(); });
        });
      });
      return true;
    }
    function renderUps(items) {
      var box = q('[data-upsell]'), list = offers(items);
      if (!list.length) { if (!renderLampUps(items)) { box.hidden = true; box.innerHTML = ''; } return; }
      box.hidden = false;
      box.innerHTML = '<div class="nx-ups__head"><span class="nx-eyebrow">Completa tu set</span><h2>Un color más, <em>menos por bolígrafo.</em></h2></div>' +
        list.map(function (o) {
          return '<div class="nx-ups__item' + (o.on ? ' is-on' : '') + '" data-k="' + o.k + '">' +
            '<label class="nx-ups__row"><span class="nx-ups__img"><img src="' + esc(o.img || cfg.fallbackImg) + '?width=160" alt="" width="64" height="64" loading="lazy"></span>' +
            '<span class="nx-ups__txt"><strong>' + esc(o.title) + '</strong><small>' + esc(o.sub) + '</small></span>' +
            '<span class="nx-ups__price">' + priceOf(o) + '</span>' +
            '<input type="checkbox" class="nx-switch" role="switch" data-toggle' + (o.on ? ' checked' : '') + ' aria-label="' + esc(o.title + ', ' + priceOf(o)) + '"></label></div>';
        }).join('');
      list.forEach(function (o) {
        var tg = box.querySelector('[data-k="' + o.k + '"] [data-toggle]');
        tg.addEventListener('change', function () {
          if (busy) { tg.checked = !tg.checked; return; }
          if (o.on && !tg.checked) { change(o.cur.key, 0); return; }
          if (!tg.checked) return;
          var pre = o.cur && o.cur.variant_id !== o.add ? tonesOf(o.cur).map(toneOf).filter(Boolean) : [];
          var opened = openSheet({
            need: o.need, picked: pre,
            title: o.need === 1 ? 'Elige el bolígrafo extra' : 'Elige los ' + o.need + ' bolígrafos extra',
            confirm: 'Añadir · ' + priceOf(o),
            onDone: function (list2) { apply(o, list2.map(function (t) { return t.label; })); },
            onCancel: function () { tg.checked = false; }
          });
          if (!opened) { tg.checked = false; note = 'Los colores no se han cargado: recarga la página.'; noteOk = false; alertMsg(); }
        });
      });
    }
    function apply(o, values) {
      if (busy || values.length !== o.need) return;
      busy = true; note = ''; render();
      var job;
      if (o.g) {
        var ns = o.g.colors.concat(values.map(function (v) { var t = toneOf(v); return t ? t.n : ''; }));
        var items = penItems(o.to, ns, newSid()), up = {};
        o.g.lines.forEach(function (l) { up[l.key] = 0; });
        job = items ? api('cart/add.js', { items: items })
          .then(function () { return api('cart/update.js', { updates: up }); })
          .then(function (c) { cart = c; note = 'Hecho: ahora tu set tiene ' + o.n + ' bolígrafos.'; noteOk = true; return cleanup(); })
          : Promise.reject(new Error('color no disponible'));
      } else if (o.to) {
        /* prima aggiungo il set nuovo, poi tolgo quello vecchio: se qualcosa va storto non si perde nulla */
        job = api('cart/add.js', { items: [{ id: o.to, quantity: 1, properties: props(o.keep.concat(values)) }] })
          .then(function () { return api('cart/change.js', { id: o.from.key, quantity: 0 }); })
          .then(function (c) { cart = c; note = 'Hecho: ahora tu set tiene ' + (o.keep.length + values.length) + ' bolígrafos.'; noteOk = true; return cleanup(); });
      } else {
        job = api('cart/add.js', { items: [{ id: o.add, quantity: 1, properties: props(values, { _naelis_addon: '1' }) }] })
          .then(function () { return o.cur && o.cur.variant_id !== o.add ? api('cart/change.js', { id: o.cur.key, quantity: 0 }) : load(); })
          .then(function (c) { cart = c; note = o.need === 1 ? 'Bolígrafo añadido a tu set.' : 'Bolígrafos añadidos a tu set.'; noteOk = true; });
      }
      job.catch(function (e) { note = 'No hemos podido actualizar el carrito: ' + e.message + '.'; noteOk = false; return load(); })
        .then(function () { busy = false; render(); });
    }

    function render() {
      if (!cart) return;
      var items = cart.items.filter(function (i) { return i.variant_id !== cfg.remove; }), lines = q('[data-lines]');
      lines.innerHTML = '';
      if (!items.length) {
        lines.innerHTML = '<div class="nx-empty"><img src="' + esc(cfg.fallbackImg) + '?width=700" alt="Glossy Pen Naelis"><div><span class="nx-eyebrow">Tu carrito está vacío</span><h3>Tu próximo color te espera.</h3><p>Elige el set y créalo entre ' + (tones().tones.length || 48) + ' colores.</p><a class="nx-btn" href="' + esc(cfg.productUrl) + '">Crea tu set</a></div></div>';
      } else {
        groupsOf(items).forEach(function (g) { lines.appendChild(groupLine(g)); });
        items.forEach(function (it) { if (!compOf(it) && !isGift(it) && !isLamp(it) && !isSpare(it) && !isKit(it) && !isOil(it) && !isPro(it)) lines.appendChild(line(it)); });
        items.forEach(function (it) { if (isLamp(it)) lines.appendChild(lampLine(it)); });
        items.forEach(function (it) { if (isGift(it)) lines.appendChild(giftLine(it)); });
        items.forEach(function (it) { if (isSpare(it)) lines.appendChild(spareLine(it)); });
        items.forEach(function (it) { if (isKit(it)) lines.appendChild(kitLine(it)); });
        items.forEach(function (it) { if (isOil(it)) lines.appendChild(oilLine(it)); });
      }
      lines.classList.toggle('is-busy', busy);

      var proAmt = items.filter(isPro).reduce(function (n, i) { return n + (i.final_line_price || 0); }, 0);
      var total = cart.total_price || 0, sub = (cart.original_total_price || cart.items_subtotal_price || total) - proAmt, disc = Math.max(0, sub + proAmt - total);
      q('[data-sub]').textContent = eur(sub); q('[data-total]').textContent = eur(total); q('[data-bar-total]').textContent = eur(total);
      q('[data-disc-row]').hidden = !disc; if (disc) q('[data-disc]').textContent = '− ' + eur(disc);

      var ship = q('[data-ship]'), free = cfg.free || 0; total = total - proAmt;
      ship.hidden = !items.length || !free;
      if (items.length && free) {
        var done = total >= free;
        ship.classList.toggle('is-done', done);
        q('[data-ship-text]').innerHTML = done ? '✓ Tienes <b>envío gratis</b> a España.' : 'Te faltan <b>' + eur(free - total) + '</b> para el envío gratis.';
        q('[data-ship-bar]').style.width = Math.min(100, total / free * 100) + '%';
        q('[data-ship-cost]').textContent = done ? 'Gratis' : 'Calculado en el checkout';
      }
      renderUpgrade(items);
      renderUps(items);
      renderProtect(items);

      var has = cart.item_count > 0;
      q('[data-checkout]').disabled = busy || !has; q('[data-bar-btn]').disabled = busy || !has; q('[data-bar]').hidden = !has;
      alertMsg();
      document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (s) { s.textContent = cart.item_count; });
    }
    function change(key, qty, el) {
      if (busy) return; busy = true; note = ''; if (el) el.classList.add('is-busy');
      api('cart/change.js', { id: key, quantity: Math.max(0, qty) }).then(function (c) { cart = c; return cleanup(); })
        .catch(function (e) { note = 'No hemos podido actualizar el carrito: ' + e.message + '.'; noteOk = false; return load(); })
        .then(function () { busy = false; render(); });
    }
    function init() {
      load().then(cleanup).then(render).catch(function (e) {
        note = 'El carrito no se ha cargado: ' + e.message + '.'; noteOk = false; alertMsg();
        q('[data-lines]').innerHTML = '<button type="button" class="nx-btn" data-retry>Reintentar</button>';
        q('[data-retry]').addEventListener('click', init);
      });
    }
    q('[data-form]').addEventListener('submit', function (e) { if (busy || !cart || !cart.item_count) e.preventDefault(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) init(); });
    /* lampada di scorta: se il tema non la passa nella configurazione, la legge dal prodotto nascosto */
    function grab(handle) {
      return fetch(base + 'products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (pr) { var v = pr && pr.variants && pr.variants[0]; return v && v.available ? { id: v.id, price: v.price, compare: v.compare_at_price || 0, img: pr.featured_image ? pr.featured_image.replace(/^\/\//, 'https://') + (pr.featured_image.indexOf('?') < 0 ? '?' : '&') + 'width=200' : '' } : null; })
        .catch(function () { return null; });
    }
    Promise.all([KIT || grab('kit-cambio-colore'), OIL || grab('naelis-penna-nutriente-cuticole'), PRO || grab('protezione-spedizione')])
      .then(function (r) { KIT = r[0] || null; OIL = r[1] || null; PRO = r[2] || null; }).then(init, init);
  }

  /* ---------- Avvio + editor del tema ---------- */
  function boot(scope) {
    scope = scope || document;
    reveal(scope);
    scope.querySelectorAll('[data-nx-colors]').forEach(initColors);
    scope.querySelectorAll('[data-nx-product]').forEach(initProduct);
    scope.querySelectorAll('[data-nx-reviews]').forEach(initReviews);
    scope.querySelectorAll('[data-nx-cart]').forEach(initCart);
  }
  /* le pagine dei prodotti "penna per colore" non si mostrano: si torna a Glossy Pen */
  if (/\/products\/glossy-pen-(singola|set-)/.test(location.pathname) && !/design_mode|preview_theme_id=.*edit/.test(location.search)) location.replace('/products/glossy-pen');
  if (/\/products\/lampada-uv-led-scorta/.test(location.pathname) && !/design_mode/.test(location.search)) location.replace('/products/lampada-uv-led');
  if (/\/products\/kit-cambio-colore/.test(location.pathname) && !/design_mode/.test(location.search)) location.replace('/products/glossy-pen');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
